import { TradierSymbolParser } from './tradier-symbol/TradierSymbolParser';

export const symbolIsSPX = (symbol?: string): boolean => {
  let underlyingSymbol = symbol;

  if (!symbol) {
    return false;
  }

  if (symbol.length > 7) {
    const parsed = new TradierSymbolParser(symbol).parsed;

    if (!parsed) {
      // throw new Error(
      //   `Could not parse underlying symbol from option: ${symbol}`
      // );
      return false;
    }

    underlyingSymbol = parsed.underlyingSymbol;
  }

  return (
    underlyingSymbol === 'SPX' ||
    underlyingSymbol === 'SPXW' ||
    underlyingSymbol === 'I:SPX' ||
    underlyingSymbol === '^GSPC' ||
    underlyingSymbol === '^SPX'
  );
};
